import dayjs from 'dayjs'
import i18n from '@/plugins/i18n'

// 處理日期範圍欄位
export function filterDateRange(
  params,
  dateRange,
  startColumn,
  endColumn,
  format = 'YYYY-MM-DD HH:mm:ss'
) {
  if (dateRange?.length > 0) {
    switch (format) {
      case 'YYYY-MM-DD HH:mm:ss':
      case 'YYYY-MM-DD 00:00:00': {
        params[startColumn] = dayjs(dateRange[0]).format(format)
        params[endColumn] = dayjs(dateRange[1])
          .format(format)
          .replace('00:00:00', '23:59:59')
        break
      }
      case 'YYYY-MM-DD': {
        params[startColumn] = dayjs(dateRange[0]).format(format)
        params[endColumn] = dayjs(dateRange[1]).format(format)
        break
      }
    }
  } else {
    // params[startColumn] = ''
    // params[endColumn] = ''
  }
  return params
}

// 處理日期欄位
export function filterDate(params, column) {
  if (params[column]) {
    params[column] = dayjs(params[column]).format('YYYY-MM-DD HH:mm:ss')
  } else {
    params[column] = ''
  }
  return params
}

// datePicker 快捷鍵選項
export const quickDateRange = {
  [i18n.global.t('date_quick_today')]: [
    dayjs().startOf('day'),
    dayjs().endOf('day'),
  ],
  [i18n.global.t('date_quick_last_7_day')]: [
    dayjs().subtract(7, 'day').startOf('day'),
    dayjs().endOf('day'),
  ],
  [i18n.global.t('date_quick_last_30_day')]: [
    dayjs().subtract(30, 'day').startOf('day'),
    dayjs().endOf('day'),
  ],
  [i18n.global.t('date_quick_this_month')]: [
    dayjs().startOf('month'),
    dayjs().endOf('month'),
  ],
}

// datePicker 顯示所選時間
export function dateFormat(startAt, endAt) {
  return [dayjs(startAt, 'YYYY-MM-DD'), dayjs(endAt, 'YYYY-MM-DD')]
}

/**
 * 轉換時間
 * @param {number} value - The time value to be converted.
 * @param {string} unit - The unit of the time value ("hours" or "minutes").
 * @returns {string} The formatted time string.
 */
export function convertTime(value, inputUnit, outputUnit, direction = '') {
  let totalSeconds

  // 根據單位進行換算
  switch (inputUnit) {
    case 'hours':
      totalSeconds = value * 3600
      break
    case 'minutes':
      totalSeconds = value * 60
      break
    case 'seconds':
      totalSeconds = value
      break
  }

  // 構建時間字符串
  let result = ''
  switch (outputUnit) {
    case 'hours': {
      const hours = Math.floor(totalSeconds / 3600)
      const remainingMinutes = Math.floor((totalSeconds % 3600) / 60)
      if (hours > 0) {
        result += `${hours}${i18n.global.t('hour')}`
      }
      if (remainingMinutes > 0) {
        result += `${remainingMinutes}${i18n.global.t('minute')}`
      }
      break
    }
    case 'minutes': {
      const totalMinutes = Math.floor(totalSeconds / 60)
      const remainingSeconds = totalSeconds % 60
      if (totalMinutes > 0) {
        result += `${totalMinutes}${i18n.global.t('minute')}`
      }
      if (remainingSeconds > 0) {
        result += `${remainingSeconds}${i18n.global.t('second')}`
      }
      break
    }
    case 'seconds': {
      result += `${totalSeconds}${i18n.global.t('second')}`
      break
    }
    default:
      throw new Error(i18n.global.t('error.invalid_output_unit'))
  }

  // 添加时间方向
  if (direction === 'before') {
    result += i18n.global.t('timeBefore')
  } else if (direction === 'after') {
    result += i18n.global.t('timeAfter')
  }

  return result
}
